import {connect} from "react-redux";
import VoicemailViewRecording , {MapDispatchToPropsType, MapStateToPropsType} from "../organisms/ViewRecording";
import {IStateType} from "../../../store/models/root.interface";
import {closeSideBar, getParams} from "../../../store/sidebar";
import {Instances} from "../../../constants";
import {removeObjects} from "../../../store/Objects";
import withImmutablePropsToJS from "with-immutable-props-to-js";
import {makeSelectInProgress, makeSelectObject} from "../../../store/Object";

const MapStateToProps = (state:IStateType) => {
    const params = getParams(state);
    const selectData = makeSelectObject(Instances.VoicemailRecording);
    const selectInProgress = makeSelectInProgress(Instances.VoicemailRecording);
    return {
        params,
        data:selectData(state),
        inProgress:selectInProgress(state),
    }
}

const MapDispatchToProps = {
    closeModal : () => closeSideBar(),
    removeInstance : () => removeObjects(Instances.VoicemailRecording),
}

export default connect<MapStateToPropsType,MapDispatchToPropsType,unknown,IStateType>(MapStateToProps,MapDispatchToProps)(withImmutablePropsToJS(VoicemailViewRecording));